import { useState, useContext, useEffect } from "react";
import { Accordion, Row, Col, Card,useAccordionButton  } from "react-bootstrap";
import { AnimatedIconButton } from "../../../../AnimatedIconButton/AnimatedIconButton";
import ToolTip from "../../../../ToolTip/Tooltip";
import { SvgComponent } from "../../../../SvgComponent/SvgComponent";
import { CountContext } from "../../../../../Contexts";
import IconButton from "../../../../IconButton/IconButton";
function InformationSection({
  title,
  children,
  onClick,
  info,
  disabled,
  file,
  addButtonLabel,
  addButtonIcon,
  esCasoRelacionado = false,
  refresh = () => {},
  referencia,
  esCotizacionButton = false,
}) {
  let countContext = useContext(CountContext);
  const {count, setCount} = countContext
      ? countContext
      : {};
  const [isExpanded, setIsExpanded] = useState(true);
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  let componentCount = count ? `(${count})` : "";

  const fileButton = (
        <IconButton onClick={onClick} isDisabled={disabled}>
          <ToolTip message="Subir Archivo">
            <div>
              <SvgComponent iconName="Attach-file"/>
            </div>
          </ToolTip>
        </IconButton>
  );
  const addButton = (
        <AnimatedIconButton
            size="25px"
            height="12"
            width="12"
            iconName={addButtonIcon ? addButtonIcon : "plus-crm"}
            message={addButtonLabel ? addButtonLabel : `Agregar ${title}`}
            onClick={onClick ? onClick : null}
            disabled={disabled}
        />
  );
  const infoButton = (
        <IconButton onClick={onClick ? onClick : null} isDisabled={disabled}>
          <ToolTip message={`Visualizar ${title}`}>
            <div>
              <SvgComponent iconName="link"/>
            </div>
          </ToolTip>
        </IconButton>
  );
    function CustomAccordionHeader({ children, eventKey, style }) {
        const decoratedOnClick = useAccordionButton(eventKey);

        return (
            <div
                onClick={decoratedOnClick}
                style={{...style}}
            >
                {children}
            </div>
        );
    }
    return (
        <Accordion
            onClick={handleToggle}
        >
                <Accordion.Item eventKey="0">
                    <CustomAccordionHeader
                        eventKey="0"
                        style={{ cursor: 'pointer' }}>
                        <h5
                            className="card-title"
                            style={{
                                fontSize: "2vh",
                                fontWeight: "bold",
                                cursor: "pointer",
                            }}
                        >
                            <Row className="m-0 p-0 align-items-center">
                                <Col lg={1}>
                                    <SvgComponent
                                        iconName={isExpanded ? "down" : "right"}
                                        fill="#77777A"
                                    />
                                </Col>
                                <Col lg={9}>
                                    {`${title} ${componentCount}`}
                                </Col>
                                <Col sm={1}>
                                    {onClick && info ? (
                                        infoButton
                                    ) : onClick && file ? (
                                        fileButton
                                    ) : onClick ? (
                                        addButton
                                    ) : (
                                        <></>
                                    )}
                                </Col>
                            </Row>
                        </h5>
                    </CustomAccordionHeader>
                    <Accordion.Body>
                        {children}
                    </Accordion.Body>
                </Accordion.Item>
        </Accordion>
    );
}
export default InformationSection;
